const ERROR_MESSAGES: Record<string, string> = {
  'duplicate key value': 'This item already exists',
  'violates row-level security': 'You do not have permission to perform this action',
  'violates foreign key': 'Invalid reference',
  'violates check constraint': 'Invalid data provided',
  'invalid input syntax': 'Invalid data format',
  'user already registered': 'This email is already registered',
  'invalid login credentials': 'Invalid email or password',
  'email not confirmed': 'Please confirm your email address',
};

export function getSafeErrorMessage(error: any): string {
  const errorMsg = error?.message?.toLowerCase() || '';
  
  for (const [pattern, safeMsg] of Object.entries(ERROR_MESSAGES)) {
    if (errorMsg.includes(pattern)) {
      return safeMsg;
    }
  }
  
  // Generic fallback
  return 'An error occurred. Please try again.';
}

export function logError(context: string, error: any) {
  // Log full details in development only
  if (import.meta.env.MODE === 'development') {
    console.error(`[${context}]`, error);
  }
}
